// @flow

import Cookies from "js-cookie"

import { makeQuery } from "../query/queries"

// HELPERS
// ===
export function consoleLog(type: string, ...args: any) {
  if (Cookies.get("showConsoleLogs") === "true") {
    // eslint-disable-next-line
    console.info(
      `%cTRACK ${type}`,
      "padding: 0 5px; background-color: #31AD0F; color: white;",
      ...args,
    ) // eslint-disable-line no-console
  }
}

export function appendHtml(html: string | HTMLElement) {
  // noinspection JSUnresolvedVariable
  if (window.SP_GLOBALS.SKYPICKER_ENV === "production") {
    // $FlowFixMe
    $("body").append(html)
  } else {
    consoleLog("APPEND HTML", html)
  }
}

export function appendScript(url: string) {
  // noinspection JSUnresolvedVariable
  if (window.SP_GLOBALS.SKYPICKER_ENV === "production") {
    ;(() => {
      const s = document.getElementsByTagName("script")[0]
      const e = document.createElement("script")
      e.type = "text/javascript"
      e.src = url
      e.defer = true
      // $FlowFixMe
      s.parentNode.insertBefore(e, s)
    })()
  } else {
    consoleLog("SCRIPT", url)
  }
}

export function appendBookingcomScript(url: string) {
  // noinspection JSUnresolvedVariable
  ;(() => {
    const s = document.getElementById("ReservationThankyouHotelsContainer")
    const e = document.createElement("script")
    e.type = "text/javascript"
    e.src = url
    e.defer = true
    e.id = "sp_widget"
    e.dataset.hash = "_b51f3559c32b7" // booking.com widget ID
    e.dataset.size = "700x500" // default size
    e.dataset.tpncy = "false"
    // $FlowFixMe
    s.parentNode.insertBefore(e, s)
  })()
}

export function alwaysAppendScript(url: string) {
  ;(() => {
    const s = document.getElementsByTagName("script")[0]
    const e = document.createElement("script")
    e.type = "text/javascript"
    e.src = url
    e.defer = true
    e.async = true
    // $FlowFixMe
    s.parentNode.insertBefore(e, s)
  })()
}

export function appendIframe(url: string) {
  // noinspection JSUnresolvedVariable
  if (window.SP_GLOBALS.SKYPICKER_ENV === "production") {
    ;(() => {
      const iframe = document.createElement("iframe")
      iframe.scrolling = "no"
      // $FlowFixMe
      iframe.frameborder = "0"
      iframe.width = "1"
      iframe.height = "1"
      iframe.src = url
      document.getElementsByTagName("body")[0].appendChild(iframe)
    })()
  } else {
    consoleLog("IFRAME", url)
  }
}

export function appendCJTracking() {
  ;(e => {
    var t = "2586", // eslint-disable-line
      n = document,
      r,
      i,
      s = {
        http: "https://secure-cdn.mplxtms.com/s/MasterTMS.min.js",
        https: "https://secure-cdn.mplxtms.com/s/MasterTMS.min.js",
      },
      // $FlowFixMe
      o = s[/\w+/.exec(window.location.protocol)[0]]
    i = n.createElement("script")
    i.type = "text/javascript"
    i.async = !0
    i.src = `${o}#${t}`
    r = n.getElementsByTagName("script")[0]
    // $FlowFixMe
    r.parentNode.insertBefore(i, r)
    // are we sure that i.readyState exists?
    // $FlowFixMe
    i.readyState
      ? (i.onreadystatechange = function() {
          // $FlowFixMe
          if (i.readyState === "loaded" || i.readyState === "complete") i.onreadystatechange = null
        })
      : (i.onload = function() {
          // $FlowFixMe
          e()
        })
  })()
}

export function createImgElement(id: string, src: string, isPixel: boolean = false): HTMLElement {
  const img = document.createElement("img")
  img.id = id
  img.src = src
  if (isPixel) {
    img.width = 0
    img.height = 0
    img.className = "trackingPixel"
  }
  return img
}

export function getUrlFromEvent(baseUrl: string, event: { [string]: any }) {
  const query = makeQuery(event, true)
  return `${baseUrl}?${query}`
}

export function appendImagePixel(pixelId: string, baseUrl: string, event: { [string]: any }) {
  // first find out if element exists and remove it if it does
  const pixel = document.getElementById(pixelId)
  if (pixel && pixel.parentNode) {
    pixel.parentNode.removeChild(pixel)
  }

  const pixelSrc = getUrlFromEvent(baseUrl, event)
  const newPixel = createImgElement(pixelId, pixelSrc, true)

  appendHtml(newPixel)
}
